import React, { Component } from 'react'
import { connect } from '@cerebral/react'
import { state, signal, props } from 'cerebral/tags'
import filterCompute from '../../../computed/filterCompute'
import { AutoSizer, List } from 'react-virtualized'
import styles from './styles'

export default connect(
  {
    namespace: props`namespace`,
    onSelectOption: signal`selectr.onSelectOption`,
    filteredOptions: filterCompute(props`namespace`),
    focusedOption: state`selectr.${props`namespace`}.focusedOption`,
    setFocusedOption: signal`selectr.setFocusedOption`,
    unFocusOption: signal`selectr.unFocusOption`,
    optionsClosed: state`selectr.${props`namespace`}.optionsClosed`
  },
  class Options extends Component {
    constructor(props, context) {
      super(props, context)
      this.rowRenderer = this.rowRenderer.bind(this)
    }

    rowRenderer({ index, isScrolling, key, style }) {
      const {
        filteredOptions,
        setFocusedOption,
        focusedOption,
        onSelectOption,
        namespace,
        overrideStyles
      } = this.props
      const option = filteredOptions[index]

      let optionStyle = { ...style, ...styles.option }
      if (focusedOption === index) {
        optionStyle = { ...optionStyle, ...styles.selected }
      }
      if (overrideStyles && overrideStyles.options) {
        const { option, selected } = overrideStyles.options
        if (option) {
          optionStyle = { ...optionStyle, ...option }
        }
        if (selected) {
          if (focusedOption === index) {
            optionStyle = { ...optionStyle, ...selected }
          }
        }
      }

      return (
        <div
          key={key}
          style={optionStyle}
          onClick={e => onSelectOption({ namespace, index })}
          onMouseEnter={e => {
            if (!isScrolling) {
              setFocusedOption({ namespace, index })
            }
          }}>
          {option.label}
        </div>
      )
    }

    render() {
      const {
        filteredOptions,
        unFocusOption,
        optionsClosed,
        namespace,
        overrideStyles,
        focusedOption
      } = this.props
      if (filteredOptions.length === 0 || optionsClosed) {
        return null
      }

      let optionStyle = { ...styles.option }
      let containerStyle = { ...styles.container }
      if (overrideStyles && overrideStyles.options) {
        const { option = {}, container = {} } = overrideStyles.options
        optionStyle = { ...optionStyle, ...option }

        if (container) {
          containerStyle = { ...containerStyle, ...container }
        }
      }

      let { padding, height } = optionStyle
      const rowHeight = padding * 2 + height
      const rowCount = filteredOptions.length
      const listHeight =
        rowCount * rowHeight > containerStyle.height
          ? containerStyle.height
          : rowCount * rowHeight

      containerStyle = { ...containerStyle, height: listHeight }

      return (
        <div
          style={{
            display: 'flex',
            width: '100%',
            position: 'relative'
          }}>
          <div
            onMouseLeave={e => unFocusOption({ namespace })}
            style={containerStyle}
            ref={filterContainerRef => {
              this.filterContainerRef = filterContainerRef
            }}>
            <AutoSizer disableHeight>
              {({ width }) => (
                <List
                  height={listHeight}
                  overscanRowCount={0}
                  noRowsRenderer={() => {
                    return null
                  }}
                  rowCount={rowCount}
                  rowHeight={rowHeight}
                  rowRenderer={this.rowRenderer}
                  scrollToIndex={focusedOption || 0}
                  width={width}
                />
              )}
            </AutoSizer>
          </div>
        </div>
      )
    }
  }
)
